<div class="onboarding-step-wrapper">
    <h2>Auto-generate long-term maintenance asset types</h2>
    <div class="onboarding-blurb">
        <p>
            If Long-term Maintenance (LTM) is enabled for your organisation, you may choose to auto-generate an initial set of long-term maintenance items.
        </p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <ng-container *ngIf="active else showInactive">
                <p class="onboarding-prompt">Auto-generate long-term maintenance asset types is on.<br/>Do you want to turn auto-generate long-term maintenance asset types off?</p>
                <button (click)="submit(false)" class="cas-button-action">Turn off</button>
            </ng-container>

            <ng-template #showInactive>
                <p class="onboarding-prompt">Auto-generate long-term maintenance asset types is off.<br/>Do you want to turn auto-generate long-term maintenance asset types on?</p>
                <button (click)="submit(true)" class="cas-button-action">Turn on</button>
            </ng-template>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
